export default __webpack_public_path__ + "static/media/made.b134d576.png";